import React, { useEffect, useState, useCallback, useRef } from "react"
import { useDropzone } from "react-dropzone";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, Spinner } from 'reactstrap';
import classes from './MediaUpload.module.scss';
import blobify from "../../drive/TruckForm/TruckImageBlobifier";
import axios from "axios";
import Compressor from 'compressorjs';
import { boxiPrimary } from "../../../../assets/style/colors";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import InfoIcon from '@mui/icons-material/Info';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import _ from 'lodash';

const MediaUpload = ({ isModalOpen, openModal, setUploadedImageURL, setImagePath }) => {

  const alertRef = useRef(null);
  const [image, setImage] = useState(null)
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isImageIsProcessing, setIsImageIsProcessing] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [compressedFilesToUpload, setCompressedFilesToUpload] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMaxSizeExceeded, setIsMaxSizeExceeded] = useState(false);
  const [totalImagesSize, setTotalImagesSize] = useState(0);
  const maxImagesSize = 5*1024*1024; // 5MB

  useEffect(() => {
    return () => {
      setFilesToUpload([])
    }
  }, [])

  const truckImageChangeHandler = (file) => {
    setImage(file)
  };

  const blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  // const onDrop = useCallback((acceptedFiles) => {
  //   setIsImageIsProcessing(true);
  //   acceptedFiles.forEach(async (file) => {
  //     allAcceptedFiles.push(file);

  //     try {
  //       new Compressor(file, {
  //         quality: 0.1,
  //         success(result) {
  //           blobToBase64(result).then(res => {
  //             filesToUpload.push({
  //               file_name: file.name,
  //               data_url: res
  //             });
  //           })
  //         },
  //         error(err) {
  //           console.log(err.message);
  //         },
  //       });
  //       console.log(filesToUpload);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   });
  //   truckImageChangeHandler(filesToUpload);
  // }, filesToUpload);

  // const onDrop = useCallback((acceptedFiles) => {
  //   acceptedFiles.forEach(async (file) => {
  //     allAcceptedFiles.push(file);

  //     try {
  //       let base64 = await readFileAsync(file);
  //       filesToUpload.push({
  //         file_name: file.name,
  //         data_url: base64
  //       });
  //       console.log(filesToUpload);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   });
  //   truckImageChangeHandler(filesToUpload);
  // }, filesToUpload);

  // const onDrop = useCallback(async (acceptedFiles) => {
  //   console.log("🚀 ~ file: MediaUpload.js:92 ~ onDrop ~ acceptedFiles:", acceptedFiles)
  //   try {
  //     const filePromises = acceptedFiles.map(async (file) => {
  //       try {
  //         let base64 = await readFileAsync(file);
  //         filesToUpload.push({
  //           file_name: file.name,
  //           data_url: base64
  //         });
  //       } catch (err) {
  //         console.log("Error reading file:", err);
  //         return null;
  //       }
  //     });
  
  //     const processedFiles = await Promise.all(filePromises);
  //     const filteredFiles = processedFiles.filter((file) => file !== null);
  
  //     allAcceptedFiles.push(...acceptedFiles);
  //     filesToUpload.push(...filteredFiles);
  
  //     truckImageChangeHandler(filesToUpload);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, []);

  // const truckImageChangeHandler = (files) => {
  //   // Implement your logic for handling the uploaded images here
  //   console.log("Files uploaded:", files);
  // };

  const formatSize = (bytes) => {
    if (bytes < 1024) {
      return bytes + "B";
    } else if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + "KB";
    } else {
      return (bytes / (1024 * 1024)).toFixed(2) + "MB";
    }
  };

  const onDrop = useCallback(async (acceptedFiles) => {
    try {
      setIsLoading(true);
      setIsImageIsProcessing(true);
      const filePromises = acceptedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            new Compressor(file, {
              quality: 0.1,
              success(result) {
                blobToBase64(result).then(res => {
                  const tempCompressedImages = _.cloneDeep(compressedFilesToUpload)
                  tempCompressedImages.push({
                    file_name: file.name,
                    data_url: res,
                    size_in_bytes: result.size,
                    formatted_size: formatSize(result.size),
                    original_size: formatSize(file.size)
                  })
                  setCompressedFilesToUpload((prevFiles) => [...prevFiles, {
                    file_name: file.name,
                    data_url: res,
                    size_in_bytes: result.size,
                    formatted_size: formatSize(result.size),
                    original_size: formatSize(file.size)
                  }]);
                  setTotalImagesSize((prev) => prev + result.size)
                  setIsImageIsProcessing(false);
                  truckImageChangeHandler(tempCompressedImages);
                })
              },
              error(err) {
                console.log(err.message);
              },
            });
            resolve({
              file_name: file.name,
              data_url: reader.result,
              size: formatSize(file.size)
            });
          };
          reader.onerror = (error) => {
            console.log("Error reading file:", error);
            reject(error);
          };
          reader.readAsDataURL(file);
        });
      });

      const processedFiles = await Promise.all(filePromises);
      const filteredFiles = processedFiles.filter((file) => file !== null);

      // Update the state with the new files to trigger re-rendering
      setFilesToUpload((prevFiles) => [...prevFiles, ...filteredFiles]);
      setIsLoading(false);
      truckImageChangeHandler(compressedFilesToUpload);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const truckUploadPictureHandler = async () => {
    try {
      setIsImageUploading(true);
      // Create an object of formData
      const formData = new FormData();
      
      for (let i = 0; i < compressedFilesToUpload.length; i++) {
        var blob = blobify(compressedFilesToUpload[i].data_url);
        formData.append("images", blob, compressedFilesToUpload[i].file_name);
      }

      // Update the formData object
      const res = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_HOST}/communication/chat/upload-sms-media`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(res);
      setIsImageUploading(false);
      setUploadedImageURL(res.data.uploaded_images);
      setImagePath(compressedFilesToUpload);
      setTimeout(() => {
        openModal(false);
      }, 1000);
    } catch (error) {
      console.log(error);
      setIsImageUploading(false);
    }
  };

  useEffect(() => {
    if (totalImagesSize > maxImagesSize) setIsMaxSizeExceeded(true);
    else setIsMaxSizeExceeded(false);
  }, [totalImagesSize])

  const removeImage = (index) => {
    const tempImages = _.cloneDeep(compressedFilesToUpload);
    const removedImage = tempImages.splice(index, 1);
    setCompressedFilesToUpload(tempImages);
    setTotalImagesSize((prev) => prev - removedImage[0].size_in_bytes);
  }

  return (
    <Modal backdrop="static" className={classes.modalDialog} isOpen={isModalOpen}>
      <ModalHeader >Upload Image</ModalHeader>
      <ModalBody style={{ position: 'relative' }}>
        {isImageIsProcessing && <div className={classes.loaderOverlay}>
          <Spinner style={{ color: boxiPrimary }} />
        </div>}
        <section className={classes.wrapper}>
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} type="file" accept="image/*" />
            <div className={classes.upload}>
              <div>Drag & drop truck images here, or click to select files</div>
            </div>
          </div>
          <div className={classes.imgContainer}>
            {isLoading ? (
              <div>Loading...</div>
            ) : compressedFilesToUpload.length > 0 ? (
              compressedFilesToUpload.map((file, index) => (
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', rowGap: 6, position: 'relative' }}>
                  <img height={150} src={file?.data_url} key={file.file_name} />
                  <HighlightOffIcon style={{ color: 'rgb(130 130 130)', cursor: 'pointer', position: 'absolute', top: -12, right: -12, background: 'white', borderRadius: '50%' }} onClick={() => removeImage(index)} />
                  <div style={{ fontSize: 12, color: 'rgb(130 130 130)', display: 'flex', alignItems: 'center', columnGap: 4 }}>{file.original_size} <ArrowRightAltIcon /> {file.formatted_size}</div>
                </div>
              ))
            ) : (
              <div style={{ color: 'rgb(130 130 130)', fontSize: 12 }}>No image selected</div>
            )}
          </div>
        </section>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className={isMaxSizeExceeded ? classes.shakeAnimation: ''} style={{ display: 'flex', alignItems: 'center', columnGap: 4 }}>
            <InfoIcon fontSize="small" style={{ color: isMaxSizeExceeded ? 'rgb(170 30 30)' : 'rgb(130 130 130)' }} />
            <div className={isMaxSizeExceeded ? classes.infoError : classes.info} style={{ fontSize: 12 }}>Commulative size of images should not exceed 5MB</div>
          </div>
          <div style={{ color: 'rgb(130 130 130)', fontSize: 12 }}>
            {formatSize(totalImagesSize)}/5MB
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button disabled={isImageUploading || isImageIsProcessing || filesToUpload.length === 0 || isMaxSizeExceeded} color="primary" onClick={truckUploadPictureHandler}>
          {isImageUploading ? 
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Spinner
                  style={{ width: "1.2rem", height: "1.2rem" }}
                  type="border"
                  color="light"
                  className="spinner-border-sm"
                />
            </div>
            :
            <span>Upload</span>
          }
        </Button>
        <Button disabled={isImageUploading || isImageIsProcessing} color="secondary" onClick={() => openModal(false)}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;
    reader.onabort = reject;

    reader.readAsDataURL(file);
  });
}

export default MediaUpload